import type { LucideIcon } from 'lucide-react'
import { createContext } from 'react'

export interface PinnedItem {
  title: string
  url: string
  icon?: LucideIcon
}

export interface PinnedSidebarContextType {
  pinnedItems: PinnedItem[]
  isPinned: (url: string) => boolean
  pinItem: (item: PinnedItem) => void
  unpinItem: (url: string) => void
  togglePin: (item: PinnedItem) => void
  isLoading: boolean
}

/**
 * Generate organization-specific preference key for pinned sidebar items
 * @param orgId - The organization ID (optional, falls back to 'default')
 */
export const getPinnedSidebarPreferenceKey = (orgId?: string) =>
  `pinned-sidebar-items${orgId ? `-${orgId}` : '-default'}`

export const PinnedSidebarContext = createContext<PinnedSidebarContextType | undefined>(undefined)
